import { MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { ConfigurationService } from './service/configuration.service';

const PUBLIC_BOOTSTRAP_PATHS = [
  '/landing',
  '/quote-assessment',
  '/verify-otp',
  '/claim/assignment',
  '/claim/estimate',
  '/claim/invoice',
  '/feedback',
  '/approval',
  '/onboarding',
  '/trial-account',
  '/agentix-trial-signup',
  '/vehicle-inspection-preview',
  '/file-claim',
  '/error/',
  '/ai-agent-external-assistant',
  '/external-payment-status'
];

/**
 * True when the current path skips authenticated platform config load.
 * @param pathname Location pathname from the current window.
 * @returns Whether APP_INITIALIZER should skip validateAndPullConfigFile.
 */
export function isPublicBootstrapPath(pathname: string): boolean {
  return PUBLIC_BOOTSTRAP_PATHS.some((fragment) => pathname.includes(fragment));
}

/**
 * Loads the MSAL redirect result once, then tenant configuration before bootstrap continues.
 * Subscribing without take/first left handleRedirectObservable open; in zoneless Angular 21
 * later MSAL emissions re-fetched user-Details and restarted SignalR hubs while idle.
 * @param configurationService Platform configuration loader.
 * @param msalService MSAL redirect handler.
 * @returns APP_INITIALIZER factory that resolves after the first redirect emission.
 */
export function appConfigFactory(configurationService: ConfigurationService, msalService: MsalService): () => Promise<boolean> {
  return async (): Promise<boolean> => {
    try {
      await firstValueFrom(msalService.handleRedirectObservable());
      if (!isPublicBootstrapPath(window.location.pathname)) {
        await configurationService?.validateAndPullConfigFile();
      }
    } catch (err) {
      console.log(err);
    }
    return true;
  };
}
